export default __webpack_public_path__ + "static/cloud_1-f55c627c7285523ea3d4caea7a960b33.png";